import { render, staticRenderFns } from "./AdviceList.vue?vue&type=template&id=6f5502b5&"
import script from "./AdviceList.vue?vue&type=script&lang=js&"
export * from "./AdviceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports